// React-Screen CBKFunctions - Strangler Phase 5 (entschalt).
// Runbook: tools/REACT-STRANGLER.md.
// ENTSCHALT am 23.8.2026 (Nutzer-Vorgabe: keine Huellen mehr, verbindlich
// sind Pixelgleichheit und 100% Funktionalitaet). React rendert die
// Knoepfe jetzt selbst ueber den gemeinsamen Baustein SecondaryPanel;
// der Legacy-Widget-Baum aus LYT_secondaryPanel.xml kommt nicht mehr vor.
// Die HANDLER sind weiter ueber spec.legacyMethods WOERTLICH uebernommen
// (Bridge-Vertrag 8) - `this`/`me` ist die Bridge.
import { defineReactScreen } from '../bridge.js';
import { SecondaryPanel } from '../secondaryPanel.jsx';

const legacy = {};


legacy.setMain = function(main) {
    this.Main = main;
}

legacy.setCallback = function() {
    POS.events.setOnClickEventCallback(this, this.disappear, true);
}

legacy.disappear = function(me) {
    me.Main.lastSubmenuId = "BK";
    window.setTimeout(me.Main.restoreLastSubmenuId, 0, me.Main);
    /*me.properties.styles.visibility = "hidden";
    me.reStyle();*/
	document.getElementById(me.id).style.visibility="hidden";
}

legacy.activateBK = function(component, parameters) {
    var me = POS.getComponentById(parameters[0]);

    if (POS.EnvProperties.BANKOMATTERMINAL == "NO") {
        POS.EnvProperties.BANKOMATTERMINAL = "YES";
        if (POS.EnvProperties.BANKOMATTERMINALIP && POS.EnvProperties.BANKOMATTERMINALIP.length > 7) {
            POS.Bankomat = new CZVTBankomatHandler();
	    POS.Bankomat.client = POS.wsclient;  
      } else {
            POS.Bankomat = new CBankomat();
        }
        var text = POS.lang.getText("MESSAGES", "BANKOMAT_ON");
        POS.message.show(text, "info", "OK");
    } else if (POS.EnvProperties.BANKOMATTERMINAL == "YES") {
        POS.EnvProperties.BANKOMATTERMINAL = "NO";
        //        var text = POS.lang.getText("MESSAGES", "BANKOMAT_ALREADY_ON");
        var text = "Angeschlossener Bankomat ist deaktiviert! Bitte mobilen Bankomat verwenden!";
        POS.message.show(text, "warning", "OK");
    }
}

legacy.creditCardBalance = function(component, parameters) {
    var me = POS.getComponentById(parameters[0]);

    POS.bankomatActive = true;
    POS.Bankomat.creditCardBalance(me);

    window.text = POS.lang.getText("MESSAGES", "EXECUTING_CREDIT_CARD_BALANCE");
    POS.hourGlass.show(text, null, null);
}



legacy.onCreditCardBalance = function(me, message, voucher) {
    POS.hourGlass.hide();
    POS.bankomatActive = false;

    if (!voucher) {
        POS.message.show("Bankomat-Meldung: " + message + "<br><br>Wiederholen?",
            "warning", "YESNO", me, POS.Bankomat.creditCardBalance);
        return;
    }

    var initBonTable = true;

    for (window.i = 0; i < voucher.dataSets.length; window.i++) {
        if (voucher.dataSets[i].sum != null) {
            if (!voucher.dataSets[i].isCopy) {
                var creditCardsSum = parseFloat(voucher.dataSets[i].sum);
                me.registerCardsBalance(me, "BKC", creditCardsSum, voucher.dataSets[i].ccc, initBonTable);
                initBonTable = false;
            }
        }
    }

    var text = "Kreditkartenabschluss:<br><br>" + message + "<br>";
    POS.message.show(text, "info", "OK");
}

legacy.cardBalance = function(component, parameters) {
    var me = POS.getComponentById(parameters[0]);

    POS.bankomatActive = true;
    $.when(me.getAllPrevCardBalances("debit")).then(function(TKSum) {
        POS.bankomatActive = true;
        $.when(POS.Bankomat.cardBalance(me, TKSum)).done(function() {

        });
    });

    window.text = POS.lang.getText("MESSAGES", "EXECUTING_CREDIT_CARD_BALANCE");
    POS.hourGlass.show(text, null, null);
}


legacy.onCardBalance = function(me, message, voucher) {
    POS.hourGlass.hide();
    POS.bankomatActive = false;

    if (!voucher) {
        POS.message.show("Bankomat-Meldung: " + message + "<br><br>Wiederholen?",
            "warning", "YESNO", me, POS.Bankomat.cardBalance);
        return;
    }

    var initBonTable = true;

    //  for (i = 1; i < voucher.dataSets.length; i++) {

    var iterator = function it(i) {

        if (i < voucher.dataSets.length) {
            if (voucher.dataSets[i].sum != null) {
                if (!voucher.dataSets[i].isCopy) {
                    var creditCardsSum = parseFloat(voucher.dataSets[i].sum);
                    var type = "BKC";
                    if (i == 0) {
                        type = "BKD";
                    }
                    $.when(me.registerCardsBalance(me, type, creditCardsSum, voucher.dataSets[i].ccc, initBonTable)).then(function() {
                        iterator(i + 1);
                    });
                    if (i > 0) initBonTable = false; // dann ist Kredit and debit in BON registriert
                } else {
                    iterator(i + 1);
                }
            } else {
                iterator(i + 1);
            }
        } else {
            var text = "Kartenabschluss:<br><br>" + message + "<br>";
            POS.message.show(text, "info", "OK");
        }
    }
    iterator(0);

    /*    if (voucher.dataSets[0].sum)
                me.registerCardsBalance(me, "BKD", parseFloat(voucher.dataSets[0].sum), voucher.dataSets[0].ccc, false);
*/

}



legacy.debitCardBalance = function(component, parameters) {
    var me = POS.getComponentById(parameters[0]);

    me.doDebitCardBalance(me);
}

legacy.doDebitCardBalance = function(me) {
    POS.bankomatActive = true;
    $.when(me.getAllPrevCardBalances("debit")).then(function(TKSum) {
        $.when(POS.Bankomat.debitCardBalance(me, TKSum)).done(function() {

            window.text = POS.lang.getText("MESSAGES", "EXECUTING_DEBIT_CARD_BALANCE");
            POS.hourGlass.show(text, null, null);
        });
    });
}




legacy.onDebitCardBalance = function(me, message, voucher) {
    POS.hourGlass.hide();
    POS.bankomatActive = false;

    if (!voucher) {
        POS.message.show("Bankomat-Meldung: " + message + "<br><br>Wiederholen?",
            "warning", "YESNO", me, me.doDebitCardBalance);
        return;
    }

    var text = "Debitkartenabschluss:<br><br>" + message + "<br>";
    POS.message.show(text, "info", "OK", me, me.showCardBalance);

    if (voucher.sum)
        me.registerCardsBalance(me, "BKD", voucher.sum, null, true);
}

legacy.printCardBillAgain = function(component, parameters) {

  return; //nicht implementiert
    var me = POS.getComponentById(parameters[0]);

    var text = POS.lang.getText("MESSAGES", "EXECUTING_CARD_BILL_REPETITION");
    POS.hourGlass.show(text, me, me.doPrintCardBillAgain);
}

legacy.doPrintCardBillAgain = function(me) {
    POS.bankomatActive = true;
    POS.Bankomat.resendVoucher(me);
}

legacy.onRetryTransaction = function(me, message, bankomatCallback, callbackParams) {
    me.onCancelTransaction(me, message);
}

legacy.onCancelTransaction = function(me, message) {
    POS.hourGlass.hide();
    POS.bankomatActive = false;

    var text = POS.lang.getText("MESSAGES", "BANKOMAT_NEWS") + message;
    POS.message.show(text, "warning", "OK");
}

legacy.doCancel = function() {}

legacy.onLowLevelError = function(me, message) {
    me.onCancelTransaction(me, message);
}

legacy.getAllPrevCardBalances = function(mode) {
    /*privMan.enablePrivilege (privList);*/
    var dfd = jQuery.Deferred();
    var sql = "SELECT MAX(BON_ID) AS MX FROM BON WHERE Type = ";
    switch (mode) {
        case "debit":
            sql += "'BKD'";
            break;
        case "credit":
            sql += "'BKC'";
            break;
        case "all":
            sql += "'POP'";
            break;
    }

    $.when(POS.SQLiteCon.execute(sql)).then(function(rows) {
        //if (!r.recordCount())
        if (rows.length < 1)
            var lastBonId = 0;
        else
            lastBonId = rows[0].MX;

        //r.free();
        if (!lastBonId) lastBonId = 0;
        switch (mode) {
            case "debit":
                sql = "SELECT Amount FROM BONE WHERE BON_ID > " + lastBonId +
                    " AND Type = 'PAY' AND Text2 = 'DCP' AND Interaction IS NULL"; //PDN (Anzahlung)  nicht inkludieren
                break;
            case "credit":
                sql = "SELECT Amount FROM BONE WHERE BON_ID > " + lastBonId +
                    " AND Type = 'PAY' AND Text2 = 'CCP' AND Interaction IS NULL";
                break;
            case "all":
                sql = "SELECT Amount FROM BONE WHERE BON_ID > " + lastBonId +
                    " AND (Type = 'BKC' OR Type = 'BKD') AND Interaction IS NULL";
                break;
        }
        $.when(POS.SQLiteCon.execute(sql)).then(function(rows2) {
            var amountTotal = 0;

            for (var i = 0; i < rows2.length; i++) {
                amountTotal += parseFloat(rows2[i].Amount);
                //r.moveNext();
            }

            //r.free();
            dfd.resolve(amountTotal);
            //return amountTotal;
        });
    });
    return dfd.promise();
}

legacy.registerCardsBalance = function(me, type, amount, cardType, initBonTable) {
    /*privMan.enablePrivilege (privList);*/
    var dfd = jQuery.Deferred();
    var userName = me.Main.userProps.Name;
    var userLogin = me.Main.userProps.Login;

    var d = new Date();

    if (initBonTable) {
        var sql = "INSERT INTO BON " +
            "(Closed, Start, End, POS_ID, U_ID, UName, Cancelled, Type, CUST_ID, Exported) VALUES " +
            "(-1, " + (d / 1000).toFixed(0) + ", 0, " + POS.POSId + ", " +
            userLogin + ", '" + userName + "', 0, '" + type + "', NULL, 0)";

        $.when(POS.SQLiteCon.execute(sql)).then(function() {
            $.when(POS.SQLiteCon.lastInsertId()).then(function(idBon) {

                var text1 = cardType == null ? "NULL" : "'" + cardType + "'";
                var sql2 = "INSERT INTO BONE " +
                    "(BON_ID, Type, Qty, Amount, Amount_Unit, Foreign_ID, Reference_BONE_ID, " +
                    "TS, Text1, Text2, Unit, Cancelled, ReplacedBy_BONE_ID, " +
                    "Interaction) VALUES " + "(" + idBon + ", '" + type + "', 0, " + amount +
                    ", 0, NULL, NULL, " + (d / 1000).toFixed(0) + ", " + text1 +
                    ", NULL, 'CRD', 0, 0, NULL)";

                $.when(POS.SQLiteCon.execute(sql2)).then(function() {
                    dfd.resolve();
                });

            });
        });
    } else {
        sql = "SELECT BON_ID FROM BON WHERE Type = '" + type + "' ORDER BY BON_ID DESC LIMIT 1";
        $.when(POS.SQLiteCon.execute(sql)).then(function(rows) {
            window.idBon = rows[0].BON_ID;
            //r.free();
            var text1 = cardType == null ? "NULL" : "'" + cardType + "'";
            var sql2 = "INSERT INTO BONE " +
                "(BON_ID, Type, Qty, Amount, Amount_Unit, Foreign_ID, Reference_BONE_ID, " +
                "TS, Text1, Text2, Unit, Cancelled, ReplacedBy_BONE_ID, " +
                "Interaction) VALUES " + "(" + idBon + ", '" + type + "', 0, " + amount +
                ", 0, NULL, NULL, " + (d / 1000).toFixed(0) + ", " + text1 +
                ", NULL, 'CRD', 0, 0, NULL)";

            $.when(POS.SQLiteCon.execute(sql2)).then(function() {
                dfd.resolve();
            });
        });
    }
    return dfd.promise();

}


function CBKFunctionsScreen({ bridge }) {
  const t = bridge.t;

  // Dieselbe Fallunterscheidung wie im Legacy-prepare/makeFunctionButtons:
  // mit angeschlossenem ZVT-Terminal drei Knoepfe (Karten-Abschluss
  // zusammengelegt), ohne Terminal vier. Auch die Spaltenzahl haengt daran.
  const zvt = POS.EnvProperties.BANKOMATTERMINALIP && POS.EnvProperties.BANKOMATTERMINALIP.length > 7;

  const knoepfe = [
    { text: t('BUTTONS', 'CARD_BILL_PRINT_AGAIN'), handler: bridge.printCardBillAgain },
  ];
  if (zvt) {
    // macht aber credit und debit
    knoepfe.push({ text: 'Debit/Kredit-<br/>KartenAbschluss', handler: bridge.cardBalance });
  } else {
    knoepfe.push({ text: t('BUTTONS', 'DEBIT_BALANCE'), handler: bridge.debitCardBalance });
    knoepfe.push({ text: t('BUTTONS', 'CREDIT_BALANCE'), handler: bridge.creditCardBalance });
  }
  knoepfe.push({ text: 'Umschalten<br/>mobil', handler: bridge.activateBK });

  return <SecondaryPanel bridge={bridge} spalten={zvt ? 3 : 4} knoepfe={knoepfe} />;
}

// Legacy-Konstruktor zum Uebertragen (addclass/htmlType/rootStyles/Felder):
// function CBKFunctions(id) {
//     this.construct(id,"secondaryPanel CBKFunctions");
// 
//     this.htmlType = "span";
// 
//     this.properties = {
//         styles: {}
//     }
// 
//     this.Main = null;
// }
export const CBKFunctions = defineReactScreen({
  className: 'CBKFunctions',
  addclass: 'secondaryPanel CBKFunctions',
  htmlType: 'span',
  Screen: CBKFunctionsScreen,
  // Kein prepare/mountLegacy mehr: das Legacy-prepare baute den
  // Widget-Baum aus LYT_secondaryPanel.xml, den rendert jetzt React
  // selbst (SecondaryPanel). Uebrig bleiben die Methoden - die sind
  // WOERTLICH die alten.
  legacyMethods: legacy,
});
